import { AvForm } from "availity-reactstrap-validation"
import UseImageUploader from "components/imageUploader/useImageUploader"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { CardTitle, Col, Modal, ModalBody, Row } from "reactstrap"

import { createCarDelivery, updateCarDelivery } from "store/actions"

const CarDeliveryModal = ({
  show,
  onCloseClick,
  updateData,
  imagesPreview,
  setImagesPreview,
}) => {
  const dispatch = useDispatch()

  const [imageError, setImageError] = useState("")

  useEffect(() => {
    if (updateData?._id) {
      setImagesPreview(updateData?.images)
    }
  }, [updateData])

  const handleValidSubmit = (e, v) => {
    if (!imagesPreview.length) {
      setImageError("Please upload one image")
      return
    }
    setImageError("") // clear error when valid

    const payload = {
      images: imagesPreview,
    }

    if (updateData?._id) {
      dispatch(updateCarDelivery(payload, updateData?._id, onCloseClick))
    } else {
      dispatch(createCarDelivery(payload, onCloseClick))
    }
  }
  useEffect(() => {
    if (imagesPreview.length > 0) {
      setImageError("")
    }
  }, [imagesPreview])
  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="p-4">
        <CardTitle>
          {updateData?._id
            ? "Edit Car Delivery Photo"
            : "Add New Car Delivery Photo"}
        </CardTitle>
        <AvForm
          onValidSubmit={(e, v) => {
            handleValidSubmit(e, v)
          }}
        >
          <Row>
            <Col className="col-12 mt-2">
              <UseImageUploader
                imageSize={4}
                setImagesPreview={images => {
                  setImagesPreview(images)
                  if (images.length > 0) setImageError("")
                }}
                imagesPreview={imagesPreview}
                uploadUrl={"/focusmotors"}
              />
              {imageError && (
                <div
                  className="text-danger mt-1"
                  style={{ fontSize: "0.9rem" }}
                >
                  {imageError}
                </div>
              )}
            </Col>
          </Row>

          <></>

          <div className="d-flex justify-content-end align-items-center">
            <div className="text-center mt-3">
              <button
                type="button"
                className="btn btn-light ms-2"
                onClick={onCloseClick}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-warning ms-2">
                {updateData?._id ? "Save" : "Create"}
              </button>
            </div>
          </div>
        </AvForm>
      </ModalBody>
    </Modal>
  )
}

CarDeliveryModal.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  updateData: PropTypes.any,
  setImagesPreview: PropTypes.any,
  imagesPreview: PropTypes.any,
}

export default CarDeliveryModal
